import { isPending } from "App/apiMiddleware";
import { getSummaryReportId } from "Areas/Sidebar/SummaryReports";
import get from "lodash/get";
import { createSelector } from "reselect";
import { NAMESPACE, PAGE_NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const getData = createSelector((state) => get(state, `[${PAGE_NAMESPACE}][${NAMESPACE}].data[${getSummaryReportId(state)}]`), (data) => data);
export const getInProgress = (state) => isPending(state, `${actionTypes.GET_SUMMARY_REPORT_DETAILS}_${getSummaryReportId(state)}`) ||
    isPending(state, `${actionTypes.SAVE_SUMMARY_REPORT_DETAILS}_${getSummaryReportId(state)}`);
